import type React from "react";
import { applyTilesToFocalPointAspectRatio } from "./applyTilesToFocalPointAspectRatio";

export function calculateStyle({
  contain,
  containerHeight,
  containerWidth,
  focalPoint,
  tiles = { rows: 1, columns: 1 },
}: {
  contain: boolean;
  containerHeight: number;
  containerWidth: number;
  focalPoint: FocalPoint;
  tiles?: Tiles;
}): React.CSSProperties {
  const style: React.CSSProperties = {};

  const focalPointAspectRatio = applyTilesToFocalPointAspectRatio({
    aspectRatio:
      focalPoint.aspectRatio ??
      (focalPoint.width || 1920) / (focalPoint.height || 1080),
    rows: tiles.rows,
    columns: tiles.columns,
  });

  const containerAspectRatio = containerWidth / containerHeight;
  const alignByWidth = contain
    ? !(containerAspectRatio > focalPointAspectRatio)
    : containerAspectRatio > focalPointAspectRatio;

  if (alignByWidth) {
    style.width = containerWidth;
    style.height = containerWidth / focalPointAspectRatio;

    // If we're contain'ed, then we want to center, not use the focal point.
    style.top =
      -(style.height - containerHeight) * (contain ? 0.5 : focalPoint.focalY);
    style.left = 0;
  } else {
    // Align by height
    style.height = containerHeight;
    style.width = containerHeight * focalPointAspectRatio;

    // If we're contain'ed, then we want to center, not use the focal point.
    style.left =
      -(style.width - containerWidth) * (contain ? 0.5 : focalPoint.focalX);
  }

  return style;
}
